import { createSlice } from "@reduxjs/toolkit"

type UserLocationShareState = {
    nodeEnabledByShareId: Record<string, boolean>
    pathEnabledByShareId: Record<string, boolean>
}
const initialState: UserLocationShareState = {
    nodeEnabledByShareId: {},
    pathEnabledByShareId: {},
}

export const userLocationShareSliceName = "userLocationShare" as const

export const {
    reducer: userLocationShareSliceReducer,
    actions: { toggleUserLocationShareNode, toggleUserLocationSharePath },
} = createSlice({
    name: userLocationShareSliceName,
    initialState,
    reducers: {
        toggleUserLocationShareNode: (state, action: { payload: { id: string } }) => {
            const { id } = action.payload
            if (!Object.keys(state.nodeEnabledByShareId).includes(id)) {
                state.nodeEnabledByShareId[id] = true
            }
            state.nodeEnabledByShareId[id] = !state.nodeEnabledByShareId[id]
        },
        toggleUserLocationSharePath: (state, action: { payload: { id: string } }) => {
            const { id } = action.payload
            if (!Object.keys(state.pathEnabledByShareId).includes(id)) {
                state.pathEnabledByShareId[id] = true
            }
            state.pathEnabledByShareId[id] = !state.pathEnabledByShareId[id]
        },
    },
})
